import React from 'react'

function Footer() {
    return (
        <div className="footer">
            <div className="footer_inner animated fadeInUp">
                <div className="social">
                    <a href="https://dribbble.com/dqve"  target="_blank" rel="noreferrer">Dribbble</a>
                    <a href="https://github.com/dqve"  target="_blank" rel="noreferrer">Github</a>
                    <a href="https://medium.com/@ayooladavid"  target="_blank" rel="noreferrer">Medium</a>
                    <a href="https://www.linkedin.com/in/david-ayo"  target="_blank" rel="noreferrer">Linkedin</a>
                </div>
                <div className="email">
                    {/* <a href="mailto:&#105;&#110;&#102;&#111;&#064;&#100;&#097;&#118;&#105;&#100;&#097;&#121;&#111;&#046;&#099;&#111;&#109;" style={{ textDecoration: "none" }}>
                        <span >Get in touch. Send an </span> <a href="mailto:&#105;&#110;&#102;&#111;&#064;&#100;&#097;&#118;&#105;&#100;&#097;&#121;&#111;&#046;&#099;&#111;&#109;">Email</a><br />
                    </a> */}
                    <a href="mailto:ayooladavid@gmail.com" style={{ textDecoration: "none" }}>
                        <span >Get in touch. Send an </span> <a href="mailto:ayooladavid@gmail.com">Email</a><br />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer